import React from 'react';
import NavbarInv from '../../components/navbarInv';
import MapaCapisInv from '../../formDataInv/mapaCapisInv';

function UbicacionCapisInv () {
    return (
        <div className='flex flex-col'>
            {/* <NavbarInv /> */}
            <MapaCapisInv />
        </div>
    )
}

export default UbicacionCapisInv;